<template>
  <v-layout align-space-around justify-start fill-height column class="pt-5">
    <v-slide-x-transition>
      <v-card class="ml-4 mr-4 mb-4">
        <v-card-text>
          <v-layout wrap justify-end>
            <v-flex xs10 sm5 md5>
              <v-layout wrap justify-space-around>
                <v-flex xs12>
                  <v-flex xs12>
                    <v-select
                      :items="[
                        { text: 'Empresa', value: 'empresa' },
                        { text: 'Posto', value: 'posto' },
                      ]"
                      v-model="filtro_vendedor"
                      label="Tipo de Vendedor"
                      item-text="text"
                      item-value="value"
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      :items="items_vendedor"
                      :disabled="!filtro_vendedor"
                      label="Filtro do Vendedor"
                      item-text="text"
                      item-value="value"
                      v-model="item_selecionado"
                      return-object
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-if="item_selecionado"
                      :disabled="!filtro_vendedor"
                      v-model="pesquisa_vendedor"
                      :label="item_selecionado.text"
                    ></v-text-field>
                  </v-flex>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    v-show="tipo_responsavel"
                    :label="tipo_responsavel === 1 ? 'ID do Cliente' : 'CNPJ da Empresa'"
                    :mask="tipo_responsavel === 1 ? '' : '##.###.###/####-##'"
                    v-model.lazy="responsavel"
                    clearable
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs2 md1 align-self-center>
              <v-btn fab small color="info" @click="pegarAssinaturas(true)">
                <v-icon>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-slide-x-transition>
      <v-data-table
        :headers="[
          {
            text: 'Descrição',
            value: 'plano.descricao',
            sortable: false
          },
          {
            text: 'Valor',
            value: 'valor',
            sortable: false
          },
           {
            text: 'Assinante',
            value: 'cliente.nome',
            sortable: false
          },
          {
            text: 'Responsável',
            value: 'empresa.nome_fantasia',
            sortable: false
          },
          {
            text: 'Data de início',
            align: 'left',
            sortable: false,
            value: 'data_inicio'
          },
          {
            text: 'Status',
            value: 'status',
            sortable: false,
            align: 'left'
          },
          {
            align: 'right',
            sortable: false
          }
        ]"
        hide-actions
        :items="assinaturas"
        :hide-headers="!assinaturas || !assinaturas.length"
        :loading="loading"
        :pagination.sync="pagination"
        :total-items="totalItens"
        no-data-text="Sem assinaturas cadastradas"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <tr>
            <td class="text-xs-left">
              <template v-if="props.item.plano">
                {{ props.item.plano.descricao || 'Não informado' }}
              </template>
              <template v-else>
                Não informado
              </template>
            </td>
            <td class="text-xs-left">
              {{ props.item.valor | currency({fractionCount: 2}) }}
            </td>
             <td class="text-xs-left">
              <template v-if="props.item.cliente">
                {{ props.item.cliente.nome }}
                {{ props.item.cliente.sobrenome }}
              </template>
            </td>
            <td class="text-xs-left">
              <template v-if="props.item.empresa">
                {{ props.item.empresa.nome_fantasia }}
                {{ props.item.empresa.cnpj }}
              </template>
              <template v-else-if="props.item.posto">
                {{ props.item.posto.nome_fantasia }}
                {{ props.item.posto.cnpj }}
              </template>
            </td>
            <td class="text-xs-left">
              <template v-if="props.item.data">
                {{ props.item.data | formatDate('DD/MM/YYYY') }}
              </template>
            </td>
            <td class="text-xs-left">
              Ativo
            </td>
          </tr>
        </template>
      </v-data-table>
    <div class="text-xs-center">
      <v-pagination v-model="pagination.page" :length="pages" circle></v-pagination>
    </div>
    <v-footer
      absolute
      dense
      style="background: transparent"
    >
      <v-expand-transition>
        <v-toolbar dense>
          <v-spacer></v-spacer>
          <v-toolbar-title>Valor Total: {{ valor_total | currency({fractionCount: 2})  }}</v-toolbar-title>
        </v-toolbar>
      </v-expand-transition>
    </v-footer>
  </v-layout>
</template>
<script>
export default {
  data () {
    return {
      status: undefined,
      tipo_responsavel: undefined,
      responsavel: undefined,
      assinaturas: [],
      filtro_vendedor: 'todos',
      item_selecionado: undefined,
      items_vendedor: [],
      pesquisa_vendedor: '',
      totalItens: 0,
      valor_total: 0,
      dates: [],
      pagination: {
        page: 1,
        rowsPerPage: 5
      },
      snackbar: {
        active: false,
        color: '',
        multiLine: true,
        timeout: 4000,
        vertical: true,
        text: ''
      }
    }
  },
  watch: {
    'pagination.page' (val) {
      if (val && this.item_selecionado) this.pegarAssinaturas(false)
    },
    filtro_vendedor (val) {
      this.item_selecionado = undefined
      switch (val) {
        case 'empresa':
          this.items_vendedor = [
            { text: 'CNPJ', value: 'plano__empresa__cnpj' },
            { text: 'Nome fantasia', value: 'plano__empresa__nome_fantasia__icontains' }
          ]
          break
        case 'posto':
          this.items_vendedor = [
              { text: 'CNPJ', value: 'plano__posto__cnpj' },
              { text: 'Nome fantasia', value: 'plano__posto__nome_fantasia__icontains' }
          ]
          break
        default:
          this.items_vendedor = []
      }
    }
  },
  computed: {
    headers () {
      return this.$store.getters.headers
    },
    loading () {
      return this.$store.getters.loading
    },
    pages () {
      const count = this.totalItens
      if (this.pagination.rowsPerPage == null || count == null) return 0

      return Math.ceil(count / this.pagination.rowsPerPage)
    }
  },
  methods: {
    showSuccess (text) {
      this.snackbar.color = 'primary'
      this.snackbar.text = text
      this.snackbar.active = true
    },
    showError (text) {
      this.snackbar.color = 'error'
      this.snackbar.text = text
      this.snackbar.active = true
    },
    pegarAssinaturas (isBtn) {
      const data = {
        page: isBtn ? 1 : this.pagination.page,
        page_size: this.pagination.rowsPerPage,
        admin: true
      }
      if (this.pesquisa_vendedor) data[`${this.item_selecionado.value}`] = this.pesquisa_vendedor
      this.$store.dispatch('pegarAssinaturas', data).then(json => {
        this.assinaturas = json.results.assinaturas
        this.valor_total = json.results.valor_total
        this.totalItens = json.count
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
